module.exports = __webpack_public_path__ + "static/img/medic.5cd887e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/medic.png
// module id = KkMw
// module chunks = 0